const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'recordController'
	],

	config: {
		entityContext: 'address',
		privilegeBase: 'artcrm_addresses',
		showTripNavButton: false,
		showCooperationNavButton: false,
		showDetailsNavButton: true,
		showRefreshNavButton: true
	},

	methods: {
		prepare: function(){
			var self = this;
			self.find('templates_artCrm_address_propertiesForm', function(properties){
				if((properties.model.nrOfTrips || 0) > 0){
					self.config.showTripNavButton = true;
				}
				if((properties.model.nrOfCooperations || 0) > 0){
					self.config.showCooperationNavButton = true;
				}
			});
		},

		showEdit: function(buttonMode, addressType, addressID, mainAddressAttributes, secondaryAddressAttributes){
			if(buttonMode === 'navToTrips' && addressType && addressID){
				var filters = {
					journalist: null,
					media: 		null,
					client: 	null,
					date: 		null,

					type: 		'all',
					status: 	'all',
					clippings: 	'all',
				};
				if(addressType === 'journalist') 	filters.journalist 	= '#' + addressID;
				else if(addressType === 'media') 	filters.media 		= '#' + addressID;
				else if(addressType === 'client') 	filters.client 		= '#' + addressID;
				getComponent('artCrmController').showEntityController('trip', filters)
			} else if(buttonMode === 'navToCooperations' && addressID){
				getComponent('artCrmController').showEntityController('cooperation', {
					anyAddress: '#' + addressID,
					client: 	null,
					media: 		null,
					contact: 	null,
					advisor: 	null,
					date: 		null
				})
			} else if(buttonMode === 'details' && mainAddressAttributes){
				var baseActionKey = 'showEdit_addressDetails';
				return this.performAndStoreAction(
					baseActionKey + '_inEffect',
					this.prepareAction(baseActionKey, undefined, {
						addresses: {
							mainAddressAttributes: 		mainAddressAttributes,
							secondaryAddressAttributes: secondaryAddressAttributes
						}
					})
				);
			}
		},

		move: function(resources, sourceAddressID, targetAddressID, direction){
			var self = this;

			if(resources && sourceAddressID && targetAddressID && (direction === 'down' || direction === 'up')){
				var movements = {};
				var d, i, data, attributes, primaryKey;
				var previousData, previousAttributes, previousPrimaryKey;
				var nextData, nextAttributes, nextPrimaryKey;
				for(d in resources || []){
					i = d * 1;

					data = resources[d] || {};
					attributes = data.attributes || {};
					primaryKey = attributes[data.primaryKey || 'id'];

					previousData = resources[i-1] || {};
					previousAttributes = previousData.attributes || {};
					previousPrimaryKey = previousAttributes[previousData.primaryKey || 'id'] || -1;

					nextData = resources[i+1] || {};
					nextAttributes = nextData.attributes || {};
					nextPrimaryKey = nextAttributes[nextData.primaryKey || 'id'] || -1;

					if(primaryKey === targetAddressID){
						if(direction === 'down'){
							movements[primaryKey] = i + 1;
						} else if (direction === 'up') {
							movements[primaryKey] = i - 1;
						}
					} else if(previousPrimaryKey === targetAddressID && direction === 'down') {
						movements[primaryKey] = i - 1;
					} else if(nextPrimaryKey === targetAddressID && direction === 'up') {
						movements[primaryKey] = i + 1;
					} else {
						movements[primaryKey] = i;
					}
				}

				if(utils.collectionSize(movements) > 0){
					return self.performAction(self.prepareAction('move_addressConnections', undefined, undefined, {
						source: {
							submit: {
								data: {
									resourceFilters: {
										movements: {
											sourceAddressID: 	sourceAddressID,
											targets: 			movements
										}
									}
								}
							}
						}
					}));
				}

				return utils.promise.reject();
			}
		}
	}
}